import { ReactComponent as ResizeIcon } from "src/img/svg/resize.svg";

import { useUiStore } from "src/components/main/uiStore";
export default function Resize(){
    const mainMenuStyle = useUiStore(state => state.mainMenuStyle);
    const setMainMenuStyle = useUiStore(state => state.setMainMenuStyle);
    const mapFull = useUiStore(state => state.mapFull);
    const setMapFull = useUiStore(state => state.setMapFull);
    const handleResize = () => {
        if(window.innerWidth > 960){
            if(mainMenuStyle && mainMenuStyle.flex === "0 0 0"){
                setMapFull(!mapFull);
                setMainMenuStyle({});
                //document.querySelector(".leaflet-container").style = null;
            }else{
                setMainMenuStyle({flex: "0 0 0", marginLeft: 0, marginRight: 0});
                window.setTimeout(() => {
                    setMapFull(!mapFull);
                }, 600 /* after transition duration*/);
            }
        }
    }
    return (
        <span className = "me-2">
            <button
                type = "button"
                className = "noButtonStyle" 
                onClick = {e => {
                    (e.currentTarget.childNodes[0] as HTMLOrSVGImageElement).classList.toggle("resizeRotate");
                    handleResize();
                }}
            >
                <ResizeIcon className = "resizeStyle"/>
            </button>
        </span>
    );
}